export default __webpack_public_path__ + "static/media/partner-13.70dc7fdc.png";